/**
 * Cookie Consent Utilities
 * 
 * localStorage yönetimi ve utility fonksiyonlar
 */

import type { CookiePreferences } from '@/types/cookie-consent';
import { COOKIE_PREFERENCES_KEY } from '@/types/cookie-consent';

/**
 * localStorage'dan çerez tercihlerini al
 */
export function getCookiePreferences(): CookiePreferences | null {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    const stored = localStorage.getItem(COOKIE_PREFERENCES_KEY);
    if (!stored) {
      return null;
    }

    const preferences = JSON.parse(stored) as CookiePreferences;
    
    // Temel validasyon
    if (
      typeof preferences.consentGiven === 'boolean' &&
      typeof preferences.timestamp === 'number' &&
      typeof preferences.version === 'string' &&
      preferences.categories &&
      typeof preferences.categories.necessary === 'boolean' &&
      typeof preferences.categories.analytics === 'boolean' &&
      typeof preferences.categories.marketing === 'boolean' &&
      typeof preferences.categories.functional === 'boolean'
    ) {
      return preferences;
    }

    return null;
  } catch (error) {
    // Sessizce hata yoksay (fallback kullanılacak)
    return null;
  }
}

/**
 * localStorage'a çerez tercihlerini kaydet
 */
export function setCookiePreferences(preferences: CookiePreferences): void {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    localStorage.setItem(COOKIE_PREFERENCES_KEY, JSON.stringify(preferences));
  } catch (error) {
    // Sessizce hata yoksay
  }
}

/**
 * Version kontrolü yap
 * Backend version ile localStorage version'ı karşılaştır
 */
export function needsReconsent(
  storedVersion: string | null,
  apiVersion: string
): boolean {
  if (!storedVersion) {
    return true; // Hiç tercih yoksa banner göster
  }

  return storedVersion !== apiVersion;
}

/**
 * Çerez tercihlerini temizle
 */
export function clearCookiePreferences(): void {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    localStorage.removeItem(COOKIE_PREFERENCES_KEY);
  } catch (error) {
    // Sessizce hata yoksay
  }
}

/**
 * Varsayılan tercihler oluştur
 */
export function createDefaultPreferences(version: string): CookiePreferences {
  return {
    consentGiven: false,
    timestamp: Date.now(),
    version,
    categories: {
      necessary: true, // Her zaman true
      analytics: false,
      marketing: false,
      functional: false,
    },
  };
}

